import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, TeamSingle, TeamPage, ServicePage, PricingPage, Gallery, CareerPage, CareerSingle, CareerForm, ProcessPage, OrderConfirmation, PartnersPage, FaqPage, BookingPage, Taxis, TaxiSingle, CasePage, CaseSingle } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} />  
        <Route path='/Team/:id' element={<TeamSingle />} />    
        <Route path='/Team/TeamSingle' element={<TeamSingle />} /> 
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Taxis*/}
        <Route path='/Taxis' element={<Taxis />} />  
        <Route path='/Taxis/:id' element={<TaxiSingle />} />
        <Route path='/Taxis/Taxi-Single' element={<TaxiSingle />} />

        {/*Services*/}
        <Route path='/Services' element={<ServicePage />} />     
        <Route path='/Services/:id' element={<ServiceSingle />} />    
        <Route path='/Services/ServiceSingle' element={<ServiceSingle />} /> 

        {/*Pages*/}
        <Route path='/Gallery' element={<Gallery />} />   

        <Route path='/CaseStudies' element={<CasePage />} />   
        <Route path='/CaseStudies/:id' element={<CaseSingle />} />   
        <Route path='/CaseStudies/CaseSingle' element={<CaseSingle />} /> 

        <Route path='/Careers' element={<CareerPage />} />    
        <Route path='/Careers/:id' element={<CareerSingle />} />    
        <Route path='/Careers/CareerSingle' element={<CareerSingle />} /> 
        <Route path='/CareerForm' element={<CareerForm />} />    

        <Route path='/Pricing' element={<PricingPage />} />    
        <Route path='/WorkProcess' element={<ProcessPage />} />    
        <Route path='/Booking' element={<BookingPage />} />    
        <Route path='/Partners' element={<PartnersPage />} />    

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 

        {/*Contact*/}
        <Route path='/contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
      
    </div>

  )
}

export default App;
